import { Component, Input, OnInit, HostListener } from '@angular/core';
import { Utils } from 'src/app/tools/utils';
import { Router } from '@angular/router';
import { Roles, IxellAPIService, Ligne, Reference, ReferenceDetails, Tarif, Retour_DLL_PAE, IxellColorWebPAE, BASES, Ingredient } from '../../tools/api.service';
import { StorageService } from 'src/app/tools/storage.service';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
    selector: 'referencedetails',
    templateUrl: './reference-details.component.html',
    styleUrls: ['./reference-details.component.scss']
})

export class ReferenceDetailsComponent implements OnInit {
    @Input() reference: Reference;
    @Input() searchCrit: SearchCrit;
    referenceDet: ReferenceDetails = new ReferenceDetails();
    role: Roles;
    ligne: Ligne;
    lignePAE: Ligne;
    haveDilutionPAE: boolean = false;
    selectedLigne: string = '';
    qte: number = 1;
    index: number = 0;
    models: string[];
    qrcode: string;
    infoQRCode: string;
    effect: string;
    category: string = "";
    tarif: Tarif;
    libTarif: string = "";
    listCategorie: string[] = [];
    isCtc: boolean = false;
    uniteSelected: string = "L";
    densiteFormule: number = 1;


    /* PAE */
    retour_DLL_PAE_initial: Retour_DLL_PAE;
    retour_DLL_PAE: Retour_DLL_PAE;
    listChoixVernis: string[] = [];
    seeListChoixVernis: boolean = false;

    choixVernisPAE: string;
    choixDilutionVernisPAE: IxellColorWebPAE;

    ixellColorWebPAE: IxellColorWebPAE[] = [];
    ixellColorWebPAECourant: IxellColorWebPAE[] = [];
    listIdIxellColorWebPAEPrecedent: number[] = [];
    seeColorWebPAE: boolean = false;
    seeRangeDilution: boolean = false;

    listChoixIxellColorWebPAE: IxellColorWebPAE[] = [];
    titlePAEDLL: string;
    subtitlePAEDLL: string;
    haveDilutionPAEDetailTitre: string;

    buttonCloseDilution: boolean = true;
    buttonPrevDilution: boolean = false;
    buttonNextDilution: boolean = false;
    densiteFormulePAE: number = 1;


    private infoSub: any;
    private modelSub: any;
    private QRCodeSub: any;
    private roleSub: any;
    private categorySub: any;
    private tarifSub: any;
    private paeSub: any;
    private paeDillutionSub: any;
    private paeGetDillutionSub: any;
    private statsLogCWTFormule: any;


    displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul"];

    constructor(private router: Router, private apiService: IxellAPIService, private storage: StorageService, private headerService: HeaderService) { }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnInit
     */
    ngOnInit() {
        window.onpopstate = function () {
        };
        let language = this.storage.get("actualLanguage");

        this.roleSub = this.headerService.currentRole.subscribe(role => {
            this.role = role;
            if (Utils.isCTC(this.role)) {
                this.isCtc = true;
                this.tarifSub = this.apiService.getTarifCtc(false).subscribe(data => {
                    this.tarif = data;
                    this.listCategorie = data.listCategorie;
                    if (this.tarif != null) {
                        this.libTarif = this.tarif.tar_lib;
                    }
                    if (this.tarifSub != null) this.tarifSub.unsubscribe();
                }, error => {
                    console.log(error);
                    if (this.tarifSub != null) this.tarifSub.unsubscribe();
                });

                this.categorySub = this.apiService.getCategoryCtc().subscribe(data => {
                    this.category = data;

                    if (data != "") {
                        this.displayedColumns.push("prix");
                        //setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 1000);
                    }
                    if (this.categorySub != null) this.categorySub.unsubscribe();
                }, error => {
                    console.log(error);
                    if (this.categorySub != null) this.categorySub.unsubscribe();
                });

            }
            if (this.roleSub != null) this.roleSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.roleSub != null) this.roleSub.unsubscribe();
        });



        this.referenceDet.vident = this.reference.vident;
        this.referenceDet.language = language.split('-')[0];
        this.referenceDet.currentReference = this.reference;
        this.referenceDet.model = this.searchCrit.model;
        this.referenceDet.year = this.searchCrit.year.toString();
        this.referenceDet.application = this.searchCrit.application;
        this.referenceDet.colorGroup = this.searchCrit.colorGroup;

        this.infoSub = this.apiService.getFormules(this.referenceDet).subscribe(data => {

            this.reference.lignes = data;
            this.index = this.reference.lignes.findIndex(f => f.numFormule == this.referenceDet.currentReference.formuleNum);
            if (this.index < 0)
                this.index = 0;
            this.ligne = data[this.index];
            let tmp = data[this.index];
            this.lignePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
            this.haveDilutionPAE = false;
            this.effect = this.ligne.effect;
            this.reference.formuleNum = this.reference.lignes[this.index].numFormule;
            this.compute();
            this.statsLogFormule();
            this.generateQRCode();
            if (this.infoSub != null) this.infoSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.infoSub != null) this.infoSub.unsubscribe();
        });
        const color = "#".concat('', this.reference.rvb);
        document.getElementById('colorRectDetails').style.backgroundColor = color;
        this.modelSub = this.apiService.getModelsForVariation(this.reference.vident).subscribe(data => {
            this.models = data;
            if (this.modelSub != null) this.modelSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.modelSub != null) this.modelSub.unsubscribe();
        });

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * ngOnDestroy
     */
    ngOnDestroy(): void {
        if (this.infoSub != null) this.infoSub.unsubscribe();
        if (this.modelSub != null) this.modelSub.unsubscribe();
        if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.categorySub != null) this.categorySub.unsubscribe();
        if (this.tarifSub != null) this.tarifSub.unsubscribe();
        if (this.paeSub != null) this.paeSub.unsubscribe();
        if (this.statsLogCWTFormule != null) this.statsLogCWTFormule.unsubscribe();
        if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
        if (this.paeGetDillutionSub != null) this.paeGetDillutionSub.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * compute
     */
    compute() {
        if (this.reference.lignes) {
            for (let j = 0; j < this.reference.lignes.length; j++) {
                for (let i = 0; i < this.reference.lignes[j].formule.length; i++) {
                    this.reference.lignes[j].formule[i].cumul += (i - 1 >= 0 ? this.reference.lignes[j].formule[i - 1].cumul : 0) + (this.reference.lignes[j].formule[i].weight * this.qte);
                }
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectLigne
     */
    selectLigne() {
        this.reference.formuleNum = this.reference.lignes[this.index].numFormule;
        this.qte = 1;
        this.ligne = this.reference.lignes[this.index];
        let tmp = this.reference.lignes[this.index];
        this.lignePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
        this.haveDilutionPAE = false;
        this.statsLogFormule();
        this.generateQRCode();
        this.effect = this.ligne.effect;
        this.selectUniteFormule();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * selectUniteFormule
     */
    selectUniteFormule() {
        if (this.uniteSelected == "L") {
            this.densiteFormule = 1;
        } else {
            this.densiteFormule = this.ligne.formule[this.ligne.formule.length - 1].cumul / 1000;
        }

        if (this.lignePAE && this.haveDilutionPAE) {
            if (this.uniteSelected == "L") {
                this.densiteFormulePAE = 1;
            } else {
                this.densiteFormulePAE = this.lignePAE.formule[this.lignePAE.formule.length - 1].cumul / 1000;
            }
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * hideKeyboard
     */
    hideKeyboard() {
        document.getElementById("qte").blur();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * printForm
     */
    printForm() {
        document.getElementById("ImgHeaderIWL").classList.add("noPrint");
        document.getElementById("contentColorwebtech").classList.add("printFormule");
        document.getElementsByClassName("mat-sidenav-content")[0].classList.add("printFormule");

        setTimeout(function () {
            window.print();
            document.getElementById("ImgHeaderIWL").classList.remove("noPrint");
            document.getElementById("contentColorwebtech").classList.remove("printFormule");
            document.getElementsByClassName("mat-sidenav-content")[0].classList.remove("printFormule");
        }, 100);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * generateQRCode
     */
    generateQRCode() {

        console.log(this.ligne);

        this.infoQRCode = "@LACA@" + this.ligne.id_Form + "#";
        this.infoQRCode += this.reference.manufacturer + "#";
        this.infoQRCode += this.reference.code + "#";
        this.infoQRCode += this.reference.designation + "#";
        this.infoQRCode += "CST" + "#";
        this.infoQRCode += this.ligne.lstInfos[0].libelle.replace(/-/gi, '') + "#";
        this.infoQRCode += this.ligne.famille;
        for (let i = 0; i < this.ligne.formule.length; i++) {
            let w: string = this.ligne.formule[i].weight.toString();
            this.infoQRCode += "#" + this.ligne.formule[i].code + "|" + this.ligne.formule[i].weight.toFixed(3);
        }
        this.QRCodeSub = this.apiService.generateQRCode(this.infoQRCode).subscribe(data => {
            this.qrcode = data;
            if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
        },
            error => {
                console.log(error);
                if (this.QRCodeSub != null) this.QRCodeSub.unsubscribe();
            }
        );
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * statsLogFormule
     */
    statsLogFormule() {
        this.statsLogCWTFormule = this.apiService.statsLogCWTFormule(this.reference.formuleNum, this.reference.technology, this.reference.lignes[this.index].ilayer).subscribe(() => {
            if (this.statsLogCWTFormule != null) this.statsLogCWTFormule.unsubscribe();
        },
            error => {
                console.log(error);
                if (this.statsLogCWTFormule != null) this.statsLogCWTFormule.unsubscribe();
            }
        );
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openQrCode
     */
    openQrCode() {
        let modal = document.getElementById("Modal");
        modal.style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeModal
     */
    closeModal() {
        let modal = document.getElementById("Modal");
        modal.style.display = "none";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openCategoryTarif
     */
    openCategoryTarif() {
        let modal = document.getElementById("ModalCategoryTarif");
        modal.style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeCategoryTarif
     */
    closeCategoryTarif() {
        let modal = document.getElementById("ModalCategoryTarif");
        modal.style.display = "none";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * initFooter
     */
    initFooter() {
        if (this.category == "") {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * setCategoryCtc
     * @param event
     */
    setCategoryCtc(event: any) {

        this.category = event.value;
        if (this.category == "") {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul", "prix"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
        this.categorySub = this.apiService.setCategoryCtc(this.referenceDet, this.category).subscribe(data => {
            this.reference.lignes = data;
            this.index = this.reference.lignes.findIndex(f => f.numFormule == this.referenceDet.currentReference.formuleNum);
            if (this.index < 0)
                this.index = 0;
            this.ligne = data[this.index];
            let tmp = data[this.index];
            this.lignePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
            this.haveDilutionPAE = false;
            this.effect = this.ligne.effect;
            this.reference.formuleNum = this.reference.lignes[this.index].numFormule;
            this.compute();
            this.statsLogFormule();
            this.generateQRCode();
            this.closeCategoryTarif();

            if (this.categorySub != null) this.categorySub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.categorySub != null) this.categorySub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * setCategoryGeneriqueCtc
     * @param event
     */
    setCategoryGeneriqueCtc(event: any) {

        this.category = event.value;
        if (this.category == "") {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.remove("active"); }, 100);
        } else {
            this.displayedColumns = ["code", "name", /*"volume",*/ "weight", "cumul", "prix"];
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[0].classList.add("active"); }, 100);
        }
        this.categorySub = this.apiService.setCategoryCtc(this.referenceDet, this.category).subscribe(data => {
            this.reference.lignes = data;
            this.index = this.reference.lignes.findIndex(f => f.numFormule == this.referenceDet.currentReference.formuleNum);
            if (this.index < 0)
                this.index = 0;
            this.ligne = data[this.index];
            let tmp = data[this.index];
            this.lignePAE = JSON.parse(JSON.stringify(tmp)); // deepclone
            this.haveDilutionPAE = false;
            this.effect = this.ligne.effect;
            this.reference.formuleNum = this.reference.lignes[this.index].numFormule;
            this.compute();
            this.statsLogFormule();
            this.generateQRCode();
            this.closeCategoryTarif();
            if (this.categorySub != null) this.categorySub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.categorySub != null) this.categorySub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * prixLitreTotal
     */
    prixLitreTotal() {
        return this.ligne.formule.reduce((cumul, courant) => cumul + Utils.roundDecimal(courant.prixlitre * (((courant.weight * this.qte / this.densiteFormule) / courant.densite) / 1000), 2), 0);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * openChoixPAE_DLL
     */
    openChoixPAE_DLL() {
        let language = this.storage.get("actualLanguage");
        this.choixDilutionVernisPAE = null;
        this.haveDilutionPAEDetailTitre = "";
        this.haveDilutionPAE = false;
        this.lignePAE = null;
        let tmp = this.ligne;
        this.lignePAE = JSON.parse(JSON.stringify(tmp));
        this.referenceDet.ligneDLLPAE = this.ligne;
        // init de du retour de DLL
        this.paeSub = this.apiService.getRetourDLLPAE(this.referenceDet, false).subscribe(data => {
            this.retour_DLL_PAE_initial = data;
            this.retour_DLL_PAE = data;
            var isFirstCoucheMulti = false;
            // execute les première étapes de la dll
            this.paeDillutionSub = this.apiService.traitementEtapeDillution(this.retour_DLL_PAE, language.split('-')[0].toLowerCase(), isFirstCoucheMulti).subscribe(dataDillution => {
                this.retour_DLL_PAE = dataDillution;
                // si le traitement de la dll est terminer => récupération via la clé de dillution des informations associé 
                if (this.retour_DLL_PAE.etapeDLL == "end") {
                    if (this.retour_DLL_PAE.psDilution != "" && this.retour_DLL_PAE.psDilution != "-1") {
                        this.GetDillutionPAE();
                    } else {
                        this.closeChoixPAE_DLL();
                    }
                } else {
                    //sinon, si étape 's10.2' => demande 'list_st_retour_choix_vernis' dans 'st_retour_choix_vernis'
                    if (this.retour_DLL_PAE.etapeDLL == "s10.2") {
                        this.listChoixVernis = this.retour_DLL_PAE.list_st_retour_choix_vernis;
                        this.seeListChoixVernis = true;
                    } else {
                        this.closeChoixPAE_DLL();
                    }
                }
            }, error => {
                console.log(error);
                if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
            });
            if (this.paeSub != null) this.paeSub.unsubscribe();
        }, error => {
            console.log(error);
            if (this.paeSub != null) this.paeSub.unsubscribe();
        });
        let modal = document.getElementById("ModalDLL_PAE");
        modal.style.display = "block";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * traitementEtapeDillution_s10_2
     */
    traitementEtapeDillution_s10_2(choixVernis: string) {
        let language = this.storage.get("actualLanguage");
        this.retour_DLL_PAE.st_retour_choix_vernis = choixVernis;
        this.choixVernisPAE = choixVernis;
        this.paeDillutionSub = this.apiService.traitementEtapeDillution(this.retour_DLL_PAE, language.split('-')[0].toLowerCase(), false).subscribe(data => {
            this.retour_DLL_PAE_initial = data;
            this.retour_DLL_PAE = data;
            // si le traitement de la dll est terminer => récupération via la clé de dillution des informations associé 
            if (this.retour_DLL_PAE.etapeDLL == "end") {
                if (this.retour_DLL_PAE.psDilution != "" && this.retour_DLL_PAE.psDilution != "-1") {
                    this.GetDillutionPAE();
                } else {
                    this.closeChoixPAE_DLL();
                }
            } else {
                this.closeChoixPAE_DLL();
            }
        }, error => {
            console.log(error);
            if (this.paeDillutionSub != null) this.paeDillutionSub.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * GetDillutionPAE
     */
    GetDillutionPAE() {
        let language = this.storage.get("actualLanguage");
        // récupération et affichage des informations associé à la dillution
        this.paeGetDillutionSub = this.apiService.getDillutionPAE(this.retour_DLL_PAE.psDilution, language.split('-')[0].toLowerCase(), this.choixVernisPAE ? this.choixVernisPAE : "", false).subscribe(dataGetDillution => {

            for (let i = 0; i < dataGetDillution.length; i++) {
                dataGetDillution[i].bdensite = parseFloat(dataGetDillution[i].bdensite.toFixed(3));
            }

            for (let i = 0; i < this.lignePAE.formule.length; i++) {
                this.lignePAE.formule[i].densite = parseFloat(this.lignePAE.formule[i].densite.toFixed(3));


                if (this.lignePAE.formule[i].bnum == "715" || this.lignePAE.formule[i].name == "VERNIS 1") {
                    let tmpChoix = this.choixVernisPAE;
                    let tmpElemIndex = dataGetDillution.findIndex(function (e, j) { return "" + e.bnum == tmpChoix; });
                    if (tmpElemIndex > -1) {
                        this.lignePAE.formule[i].bnum = "" + dataGetDillution[tmpElemIndex].bnum;
                        this.lignePAE.formule[i].code = dataGetDillution[tmpElemIndex].bcode;
                        this.lignePAE.formule[i].name = dataGetDillution[tmpElemIndex].bnom;
                        this.lignePAE.formule[i].densite = dataGetDillution[tmpElemIndex].bdensite;
                        this.lignePAE.formule[i].bintervientdansproduit = 1;
                        this.lignePAE.formule[i].typesol = 0;
                        this.lignePAE.formule[i].prixlitre = dataGetDillution[tmpElemIndex].prixLitre;
                        dataGetDillution[tmpElemIndex].bnum = 0;

                        /* maj du produit Vernis de la formule initial */
                        this.ligne.formule[0].code = dataGetDillution[tmpElemIndex].bcode;
                        this.ligne.formule[0].name = dataGetDillution[tmpElemIndex].bnom;
                        this.ligne.formule[0].densite = dataGetDillution[tmpElemIndex].bdensite;
                        this.ligne.formule[0].bintervientdansproduit = 1;
                        this.ligne.formule[0].typesol = 0;
                        this.ligne.formule[0].prixlitre = dataGetDillution[tmpElemIndex].prixLitre;
                    }

                }

            }            
            let nivsuivant = -1;
            // stock le retour initial dans ixellColorWebPAE
            this.ixellColorWebPAE = dataGetDillution;
            // masque la selection des vernis et affiche la selection des étapes de dilution
            this.seeColorWebPAE = true;
            this.seeListChoixVernis = false;
            // affiche / masque les bouton d'étapes
            this.buttonCloseDilution = true;
            this.buttonPrevDilution = false;
            this.buttonNextDilution = false;
            // la liste des choix courant est initialiser au niveau 1
            this.ixellColorWebPAECourant = dataGetDillution.filter(function (e, i) { return e.niv == 1; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
            // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (permet d'initialiser le nvsuivant si on entre dans la boucle while ou de bloquer si == 0)
            nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
            // tant qu'on a un seul choix possible, on ajoute le choix au différentes liste et on passe au choix suivant (breakLoopWhile pour éviter les boucles infini)
            var breakLoopWhile = 0;
            while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && nivsuivant != 0 && breakLoopWhile < 10) {
                // on ajout le choix courant dans la liste des sélectionner
                this.listChoixIxellColorWebPAE.push(this.ixellColorWebPAECourant[0]);
                // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (un seul choix possible car boucle while break sur this.ixellColorWebPAECourant.length != 1)
                nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
                // on ajout le niv du choix courant dans la liste id précédent
                this.listIdIxellColorWebPAEPrecedent.push(this.ixellColorWebPAECourant[0].niv);
                // le choix courant passe au suivant
                this.ixellColorWebPAECourant = dataGetDillution.filter(function (e, i) { return e.niv == nivsuivant; });
                this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
                // affiche / masque les bouton d'étapes
                this.buttonCloseDilution = false;
                this.buttonPrevDilution = true;
                this.buttonNextDilution = false;
                breakLoopWhile++;
            }
            // si nivsuivant == 0 => fin de la sélection des étapes de dilution
            if (nivsuivant == 0) {
                // vide la liste de selection possible car fin de dilution
                this.ixellColorWebPAECourant = [];
                // affiche / masque les bouton d'étapes
                this.buttonNextDilution = true;
            }
            this.writeSubtitlePAE_DLL();
        }, error => {
            console.log(error);
            if (this.paeGetDillutionSub != null) this.paeGetDillutionSub.unsubscribe();
        });
    }

    /**
     * GetOptionDillutionPAE
     */
    GetOptionDillutionPAE(choix: IxellColorWebPAE) {
        // ajout le choix de séléection d'atapes à listChoixIxellColorWebPAE
        this.listChoixIxellColorWebPAE.push(choix);
        // récupération du n°suivant pour le choix des étapes
        let nivsuivant = choix.nivsuivant;
        // affiche / masque les bouton d'étapes
        this.buttonCloseDilution = false;
        this.buttonPrevDilution = true;
        this.buttonNextDilution = false;
        // affecte la numéro courant a la liste des choix précédent
        this.listIdIxellColorWebPAEPrecedent.push(choix.niv);
        // si le choix suivant est != 0 alors on a encore des étapes de dilution
        if (nivsuivant != 0) {
            // le choix courant devient le suivant
            this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == choix.nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
            // tant qu'on a un seul choix possible, on ajoute le choix au différentes liste et on passe au choix suivant (breakLoopWhile pour éviter les boucles infini)
            var breakLoopWhile = 0;
            while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && nivsuivant != 0 && breakLoopWhile < 10) {
                // on ajout le choix courant dans la liste des sélectionner
                this.listChoixIxellColorWebPAE.push(this.ixellColorWebPAECourant[0]);
                // le choix suivant prend pour valeur le nivsuivant du premier choix de la liste (un seul choix possible car boucle while break sur this.ixellColorWebPAECourant.length != 1)
                nivsuivant = this.ixellColorWebPAECourant[0].nivsuivant;
                // on ajout le niv du choix courant dans la liste id précédent
                this.listIdIxellColorWebPAEPrecedent.push(this.ixellColorWebPAECourant[0].niv);
                // le choix courant passe au suivant
                this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant });
                this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);

                breakLoopWhile++;
            }
        }
        // si nivsuivant == 0 => fin de la sélection des étapes de dilution
        if (nivsuivant == 0) {
            // vide la liste de selection possible car fin de dilution
            this.ixellColorWebPAECourant = [];
            // affiche / masque les bouton d'étapes
            this.buttonNextDilution = true;
        }
        this.writeSubtitlePAE_DLL();
    }

    /**
     * prevChoixPAE_DLL
     */
    prevChoixPAE_DLL() {
        // on supprime le dernier ajout dans listIdIxellColorWebPAEPrecedent et on le place dans nivsuivant pour sélectionner le courant et nétoyer la liste de séléction du courant
        let nivsuivant = this.listIdIxellColorWebPAEPrecedent.pop();
        this.listChoixIxellColorWebPAE = this.listChoixIxellColorWebPAE.filter(function (e, i) { return e.niv != nivsuivant; });
        this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant; });
        this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
        // tant qu'on a un seul choix possible, on supprime le dernier ajout dans listIdIxellColorWebPAEPrecedent et on le place dans nivsuivant pour sélectionner le courant et nétoyer la liste de séléction du courant (breakLoopWhile pour éviter les boucles infini)
        var breakLoopWhile = 0;
        while (this.ixellColorWebPAECourant != null && this.ixellColorWebPAECourant.length == 1 && breakLoopWhile < 10) {
            let nivsuivant = this.listIdIxellColorWebPAEPrecedent.pop();
            this.listChoixIxellColorWebPAE = this.listChoixIxellColorWebPAE.filter(function (e, i) { return e.niv != nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAE.filter(function (e, i) { return e.niv == nivsuivant; });
            this.ixellColorWebPAECourant = this.ixellColorWebPAECourant.sort((a, b) => a.rang - b.rang);
        }

        // selon l'étape de la sélection, on affiche / masque les boutons d'étapes
        if (this.listIdIxellColorWebPAEPrecedent.length == 0) {
            this.buttonCloseDilution = true;
            this.buttonPrevDilution = false;
        } else {
            this.buttonCloseDilution = false;
            this.buttonPrevDilution = true;
        }
        // on masque systématiquement le bouton "suivant" car on est obligatoirement plus à la dernière étapes
        this.buttonNextDilution = false;

        this.writeSubtitlePAE_DLL();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * writeSubtitlePAE_DLL
     */
    writeSubtitlePAE_DLL() {
        this.subtitlePAEDLL = "";
        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {

            if (this.listChoixIxellColorWebPAE[i].messagesol1) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].messagesol1 + " /";
            } else if (this.listChoixIxellColorWebPAE[i].titre1) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].titre1 + " /";
            } else if (this.listChoixIxellColorWebPAE[i].bnom) {
                this.subtitlePAEDLL += " " + this.listChoixIxellColorWebPAE[i].bnom + " [" + this.listChoixIxellColorWebPAE[i].bcode + "]" + " /";
            }

        }

        if (this.subtitlePAEDLL.length > 1) {
            this.subtitlePAEDLL = this.subtitlePAEDLL.substring(0, this.subtitlePAEDLL.length - 1);
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * nextChoixPAE_DLL
     */
    nextChoixPAE_DLL() {

        for (let i = 0; i < this.lignePAE.formule.length; i++) {
            var tmpdensite = parseFloat(this.lignePAE.formule[i].densite.toFixed(3));
            this.lignePAE.formule[i].densite = tmpdensite;
            var tmpWeight = parseFloat(this.lignePAE.formule[i].weight.toFixed(3));
            this.lignePAE.formule[i].weight = tmpWeight;
            var tmpvolume = parseFloat(this.lignePAE.formule[i].volume.toFixed(3));
            this.lignePAE.formule[i].volume = tmpvolume;
        }

        let recalculQte = 0;
        for (let i = 0; i < this.lignePAE.formule.length; i++) {
            this.lignePAE.formule[i].bintervientdansproduit = 1;
            this.lignePAE.formule[i].typesol = 0;
            recalculQte += this.lignePAE.formule[i].densite > 0
                ? parseFloat(this.lignePAE.formule[i].weight.toFixed(1)) / this.lignePAE.formule[i].densite / 1000 
                : parseFloat(this.lignePAE.formule[i].weight.toFixed(1)) / 1000;
        }
        recalculQte = recalculQte == 0 ? 1 : recalculQte; 
        for (let i = 0; i < this.lignePAE.formule.length; i++) {
            this.lignePAE.formule[i].weight = this.lignePAE.formule[i].weight / recalculQte;
        }

        var QteTeinteGramme = 0;
        let bGrammeUniquement = true;
        let volNonPAEGramme = 0;
        let volPrecedentGramme = 0;
        let volTotalGramme = 0;
        let volNonPAE = 0;
        let volPrecedent = 0;
        let vol = 0;
        let volFormule = 0;
        let qteGrammeFormule = 0;
        this.lignePAE.formule.forEach(function (v) { qteGrammeFormule += v.weight; });
        let densiteFormule = parseFloat((qteGrammeFormule / 1000).toFixed(3));

        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {
            let choixDilution = this.listChoixIxellColorWebPAE[i];
            if (choixDilution.bnum > 0) {
                // gramme ou %
                if (choixDilution.bvolume == 0) {
                    // si bvolume == 0 mais que codemethode == 0 => alors on est en % => calcul le ratio en g nécessaire
                    if (choixDilution.codemethode == 0) {
                        switch (choixDilution.cleappli) {
                            case 0:
                                // Hors PAE
                                choixDilution.ratio1 = volNonPAEGramme * choixDilution.ratio1 / 100;
                                break;
                            case 1:
                                // Toutes bases précédentes
                                choixDilution.ratio1 = volTotalGramme * choixDilution.ratio1 / 100;
                                break;
                            case 2:
                                // Base précédente
                                choixDilution.ratio1 = volPrecedentGramme * choixDilution.ratio1 / 100;
                                break;
                        }
                    }
                    choixDilution.gramme = choixDilution.ratio1;
                    volPrecedentGramme = choixDilution.ratio1;
                    volTotalGramme += choixDilution.ratio1;

                    if (choixDilution.bintervientdansproduit == 1) {
                        volNonPAEGramme += choixDilution.volume;
                    }

                    if (choixDilution.bnum > 0 && choixDilution.bdensite > 0) {
                        choixDilution.ratio1 = choixDilution.ratio1 / 1000 / choixDilution.bdensite;
                    }

                } else {
                    bGrammeUniquement = false;
                }

                if (choixDilution.bvolume == 0) {
                    choixDilution.volume = choixDilution.ratio1;
                } else {
                    switch (choixDilution.codemethode) {
                        case 0:
                            switch (choixDilution.cleappli) {
                                case 0:
                                    choixDilution.volume = volNonPAE * choixDilution.ratio1 / 100;
                                    break;
                                case 1:
                                    choixDilution.volume = vol * choixDilution.ratio1 / 100;
                                    break;
                                case 2:
                                    choixDilution.volume = volPrecedent * choixDilution.ratio1 / 100;
                                    break;
                            }
                            break;
                        case 1:
                            choixDilution.volume = choixDilution.ratio1;
                            break;
                    }
                }

            } else {

                if (choixDilution.typesol == 5) {

                    //if (choixDilution.bvolume == 0) {
                    //    //volPrecedentGramme = choixDilution.ratio1;
                    //    //volTotalGramme += choixDilution.ratio1;

                    //    if (choixDilution.bintervientdansproduit == 1) {
                    //        volNonPAEGramme += choixDilution.volume;
                    //    }

                    //    if (densiteFormule > 0) {
                    //        choixDilution.ratio1 = choixDilution.ratio1 / 1000 / densiteFormule;
                    //    } else {
                    //        choixDilution.ratio1 = choixDilution.ratio1 / 1000;
                    //    }
                    //}

                    //switch (choixDilution.codemethode) {
                    //    case 0:
                    //        // poucentage
                    //        switch (choixDilution.cleappli) {
                    //            case 0:
                    //                // Hors PAE
                    //                choixDilution.volume = volNonPAE * choixDilution.ratio1 / 100
                    //                break;
                    //            case 1:
                    //                // Toutes bases précédentes
                    //                choixDilution.volume = volTotal * choixDilution.ratio1 / 100
                    //                break;
                    //            case 2:
                    //                // Base précédente
                    //                choixDilution.volume = volPrecedent * choixDilution.ratio1 / 100
                    //                break;
                    //        }
                    //        break;
                    //    case 1:
                    //        // Part
                    //        choixDilution.volume = choixDilution.ratio1;
                    //        break;
                    //}
                } else {
                    // Laque
                    if (choixDilution.bvolume == 0) {
                        volTotalGramme += choixDilution.ratio1;
                        volPrecedentGramme = choixDilution.ratio1;

                        if (choixDilution.bintervientdansproduit == 1) {
                            volNonPAEGramme += choixDilution.volume;
                        }

                        if (densiteFormule > 0) {
                            choixDilution.volume = choixDilution.ratio1 / 1000 / densiteFormule;
                        } else {
                            choixDilution.volume = choixDilution.ratio1 / 1000;
                        }
                    } else {
                        choixDilution.volume = choixDilution.ratio1;
                    }
                    volFormule += choixDilution.volume;
                }

            }

            volPrecedent = choixDilution.volume;
            vol += choixDilution.volume;
            if (choixDilution.bintervientdansproduit == 1) {
                volNonPAE += choixDilution.volume;
            }
        }

        if (volNonPAE == 0) {
            volNonPAE = 1
        }
        if (volFormule == 0) {
            volFormule = 1
        }
        let volProp = volNonPAE;

        for (let i = 0; i < this.listChoixIxellColorWebPAE.length; i++) {
            let choixDilution = this.listChoixIxellColorWebPAE[i];
            if (choixDilution.bnum > 0 || choixDilution.typesol == 1 || choixDilution.typesol == 5) {
                switch (choixDilution.typesol) {
                    case 0:
                        if (choixDilution.bintervientdansproduit) {
                            if (volFormule > 0) {
                                if (bGrammeUniquement) { //QteTeinteGramme
                                    if (QteTeinteGramme > 0) { // Si l'on vient d'une formule
                                        choixDilution.gramme = choixDilution.gramme * qteGrammeFormule / QteTeinteGramme;
                                    }
                                    else { // Sinon ancien code pour gérer sous couche et vernis
                                        choixDilution.gramme = choixDilution.gramme / volFormule;
                                    }
                                } else {
                                    choixDilution.gramme = (choixDilution.volume * choixDilution.bdensite * 1000) / volFormule;
                                }
                            }
                        } else {
                            if (volProp > 0) {
                                if (bGrammeUniquement) { //QteTeinteGramme
                                    if (QteTeinteGramme > 0) {
                                        choixDilution.gramme = choixDilution.gramme * qteGrammeFormule / QteTeinteGramme;
                                    } else { // Sinon ancien code pour gérer sous couche et vernis	
                                        choixDilution.gramme = choixDilution.gramme / volProp;
                                    }
                                } else {
                                    choixDilution.gramme = (choixDilution.volume * choixDilution.bdensite * 1000) / volProp;
                                }
                            }
                        }
                        break;
                    case 1:
                        break;
                    /*
                    CAS FORMULE_SECTION_MESSAGE: //********************************************************************	
                        HLitRecherche(SOLUTIONS,ID_SOLUTION,TABLE_Dilution.COL_IdSolution[nInd],hIdentique)
                        SI HTrouve(SOLUTIONS) ALORS
                            HLitRecherche(TITRE_SOL,NUM_TITRE,SOLUTIONS.NUM_AFF,hIdentique)
                            SI HTrouve(TITRE_SOL) ALORS
                                pMaFormule:stTListeIngredient[nNbIngredient]:nIdMessage = SOLUTIONS.NUM_AFF
                                pMaFormule:stTListeIngredient[nNbIngredient]:sMessage = TITRE_SOL.TITRE[Langue.IDranglangue]
                                pMaFormule:stTListeIngredient[nNbIngredient]:nDelais = SOLUTIONS.DELAI_MESS
                            FIN
                        FIN
                    */
                    //case 2:
                    //    break;
                    //case 3:
                    //case 4:
                    //    break;
                    //case 5:
                    //    break;

                }
            } else {
                QteTeinteGramme += choixDilution.gramme;
            }

            if (choixDilution.bnum > 0 && (this.listChoixVernis.indexOf("" + choixDilution.bnum) == -1) && choixDilution.ratio1 > 0) {
                let ingr: Ingredient = new Ingredient();
                ingr.bnum = "" + choixDilution.bnum;
                ingr.code = choixDilution.bcode;
                ingr.name = choixDilution.bnom;
                ingr.weight = choixDilution.gramme;
                ingr.volume = choixDilution.volume;
                ingr.densite = choixDilution.bdensite;
                ingr.prixlitre = choixDilution.prixLitre;
                ingr.bintervientdansproduit = choixDilution.bintervientdansproduit;
                ingr.typesol = choixDilution.typesol;
                ingr.cumul = -2;
                this.lignePAE.formule.push(ingr);
            }

        }

        let cumulFormulePAE = 0;
        let volumeTotal = 0;
        for (let i = 0; i < this.lignePAE.formule.length; i++) {
            if (this.lignePAE.formule[i].densite > 0) {
                volumeTotal += this.lignePAE.formule[i].weight / 1000 / this.lignePAE.formule[i].densite;
            } else {
                volumeTotal += this.lignePAE.formule[i].weight / 1000;
            }
        }

        for (let i = 0; i < this.lignePAE.formule.length; i++) {
            this.lignePAE.formule[i].weight = this.lignePAE.formule[i].weight / volumeTotal;
            cumulFormulePAE += parseFloat(this.lignePAE.formule[i].weight.toFixed(1));
            this.lignePAE.formule[i].cumul = cumulFormulePAE;
        }

        this.haveDilutionPAEDetailTitre = this.subtitlePAEDLL;

        this.haveDilutionPAE = true;

        if (this.uniteSelected == "L") {
            this.densiteFormulePAE = 1;
        } else {
            this.densiteFormulePAE = this.lignePAE.formule[this.lignePAE.formule.length - 1].cumul / 1000;
        }

        if (this.category) {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[1].classList.add("active"); }, 100);
        } else {
            setTimeout(function () { document.getElementsByClassName("formuleTabRowFooter")[1].classList.remove("active"); }, 100);
        }


        this.closeChoixPAE_DLL();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * closeChoixPAE_DLL
     */
    closeChoixPAE_DLL() {
        let modal = document.getElementById("ModalDLL_PAE");
        modal.style.display = "none";
        this.listChoixVernis = [];
        this.seeListChoixVernis = false;
        this.seeColorWebPAE = false;
        this.ixellColorWebPAE = [];
        this.ixellColorWebPAECourant = [];
        this.listChoixIxellColorWebPAE = [];
        this.listIdIxellColorWebPAEPrecedent = [];

        this.buttonCloseDilution = true;
        this.buttonPrevDilution = false;
        this.buttonNextDilution = false;

        this.subtitlePAEDLL = "";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * prixLitreTotalPAE
     */
    prixLitreTotalPAE() {
        return this.lignePAE.formule.reduce((cumul, courant) => cumul + Utils.roundDecimal(courant.prixlitre * (((courant.weight * this.qte / this.densiteFormulePAE) / courant.densite) / 1000), 2), 0);
    }

}
